export default __webpack_public_path__ + "static/media/07_photo.a4ae234d.jpg";